<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('sidelight.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'sidelights' }">{{ $t('sidelight.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <sidelight-info :sidelight="sidelight"></sidelight-info>
  </div>
</template>
<script>
import Vue from 'vue'

import { BreadcrumbPlugin } from 'bootstrap-vue'

import SidelightInfo from '@/components/info/SidelightInfo.vue'
import i18n from '@/plugins/i18n.js'
import SidelightApiService from '@/services/budaedu-api-services/sidelight-api-service.js'

Vue.use(BreadcrumbPlugin)

Vue.use(SidelightApiService)

export default {
  i18n,
  name: 'sidelight',
  props: {
    id: {
      type: Number,
      required: true
    }    
  },
  data() {
    return {
      sidelight: {},
      photos: [],
      videos: [],
      photo_compressed_files: []
    }
  },
  methods: {
    async setSidelight() {
      const item = await this.$sidelightApiService.getById(this.id)
      this.sidelight = item.data
    },
    async setSidelightPhotoCompressedFiles() { 
      const { data } = await this.$sidelightApiService.fetchPhotoCompressedFiles(this.sidelight.id)
      this.$set(this.sidelight, 'photo_compressed_files', data)
    },
    async setSidelightPhotos() { 
      const { data } = await this.$sidelightApiService.fetchPhotos(this.sidelight.id)
      this.$set(this.sidelight, 'photos', data)
    },
    async setSidelightVideos() { 
      const { data } = await this.$sidelightApiService.fetchVideos(this.sidelight.id);
      const videos = data.map(item => {
        item.name = item.description
        item.thumbnail = [
          {
            src: 'https://www2.budaedu.org/official-website-data/black.jpg',
            style: 'width:15em;height:3em;'
          }
        ]
        return item;
      }).sort((a, b) => a.name.localeCompare(b.name))
      this.$set(this.sidelight, 'videos', videos)
    }
  },
  async created() {
    // alert(`Vue version : ${Vue.version}`)
    await this.setSidelight()
    await this.setSidelightPhotoCompressedFiles()
    await this.setSidelightPhotos()
    await this.setSidelightVideos()
  },
  components: {
    SidelightInfo
  },
  metaInfo() {
    const title = this.sidelight ? this.sidelight.topic : this.$t('sidelight.title')
    return {
      title: title,
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
};
</script>